module.exports = __webpack_public_path__ + "img/handraw_bulle d'aide orange.756a11ad.svg";